export const REGION_DATA = {
  India: {
    code: "+91",
    iso: "IN",
    states: [
      "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
      "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
      "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
      "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands",
      "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir", "Ladakh",
      "Lakshadweep", "Puducherry"
    ]
  }
  // USA: {
  //   code: "+1",
  //   iso: "US",
  //   states: [
  //     "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
  //     "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  //     "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
  //     "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",
  //     "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
  //     "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
  //     "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "District of Columbia"
  //   ]
  // },
  // Canada: {
  //   code: "+1",
  //   iso: "CA",
  //   states: [
  //     "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador",
  //     "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island",
  //     "Quebec", "Saskatchewan", "Yukon"
  //   ]
  // }
};
